import { render, staticRenderFns } from "./InstagramCapabilitiesForm.vue?vue&type=template&id=51f30666"
import script from "./InstagramCapabilitiesForm.vue?vue&type=script&lang=js"
export * from "./InstagramCapabilitiesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports